import {
  takeEvery, call, all, put,
} from "redux-saga/effects";
import { addNotification, setTableSelection } from "@fas/ui-framework";
import { PAGES_LIST, PAGES_LIST_BULK_DELETE_SAGA } from "../../helpers/constants";
import type { PagesListBulkDeleteSaga } from "../../actions/pages/actions";
import { bulkDelete } from "../../services/pagesApi";
import { getPagesListSaga, removeSelectedPage } from "../../actions/pages";

export function* makeFetch(action: PagesListBulkDeleteSaga) {
  try {
    const { selectedPages } = action;
    yield call(bulkDelete, selectedPages);

    yield put(setTableSelection(PAGES_LIST, []));
    yield all(selectedPages.map((x) => put(removeSelectedPage(x))));

    yield put(addNotification({ message: "Pages deleted", severity: "success" }));

    yield put(getPagesListSaga());
  }
  catch (error: any) {
    yield put(addNotification({ message: error.errorMessage || "Failed to delete", severity: "error" }));
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export default function* watch() {
  yield takeEvery(PAGES_LIST_BULK_DELETE_SAGA, makeFetch);
}
